import { defineComponent as _defineComponent } from 'vue'
import { hyphenatedCurrentLocale } from '@@/bits/current_locale'
import device from '@@/bits/device'
import { __ } from '@@/bits/intl'
import { getLocaleName } from '@@/bits/locale'
import { navigateTo, reload } from '@@/bits/location'
import OzMenuRows, { OzMenuRowsFocusStyle, OzMenuRowsSizePreset } from '@@/library/v4/components/OzMenuRows.vue'
import { OzBoxColors } from '@@/library/v4/components/OzPopoverModal.vue'
import OzScreenSizeAwarePopoverModal from '@@/library/v4/components/OzScreenSizeAwarePopoverModal.vue'
import { useWindowSizeStore } from '@@/pinia/window_size'
import LocaleMenu from '@@/vuecomponents/LocaleMenu.vue'
import { useLocale } from '@@/vuecomposables/locale'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

enum AuthActionType {
  Help = 'Help',
  Accessibility = 'Accessibility',
  LocaleMenu = 'LocaleMenu',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthActionMenu',
  emits: ['cancel'],
  setup(__props, { emit }) {

const HELP_URL = 'https://padlet.help'
const ACCESSIBILITY_URL = 'https://padlet.com/about/accessibility'

const windowSizeStore = useWindowSizeStore()
const { isSmallerThanTabletPortrait, windowHeight } = storeToRefs(windowSizeStore)

const { changeLocale } = useLocale()

const isSelectorOpen = ref(false)
const currentLocale = ref(hyphenatedCurrentLocale)



const currentLocaleName = computed(() => getLocaleName(currentLocale.value))

const menuActions = computed(() => {
  return [
    {
      text: __('Help'),
      eventPayload: AuthActionType.Help,
      href: HELP_URL,
    },
    {
      text: __('Accessibility'),
      eventPayload: AuthActionType.Accessibility,
      href: ACCESSIBILITY_URL,
    },
    {
      text: __('Language'),
      eventPayload: AuthActionType.LocaleMenu,
      rightIcon: 'chevron_right_center',
      rightIconSize: 16,
      rightLabel: currentLocaleName.value,
      testId: 'localeMenuButtonActionMenu',
    },
  ]
})

const isPhone = computed((): boolean => {
  return device.phone || isSmallerThanTabletPortrait.value
})

const openLocaleMenu = (): void => {
  isSelectorOpen.value = true
}

const closeLocaleMenu = (): void => {
  isSelectorOpen.value = false
}

const handleChangeLocale = async (lang: string): Promise<void> => {
  isSelectorOpen.value = false

  if (currentLocale.value === lang) return

  currentLocale.value = lang
  await changeLocale(lang)

  reload()
}

const onSelectMenuRow = (_event, eventPayload: AuthActionType): void => {
  switch (eventPayload) {
    case AuthActionType.Help:
      navigateTo(HELP_URL, { target: '_blank' })
      break
    case AuthActionType.Accessibility:
      navigateTo(ACCESSIBILITY_URL, { target: '_blank' })
      break
    case AuthActionType.LocaleMenu:
      openLocaleMenu()
  }
}

const cancel = (): void => {
  closeLocaleMenu()
  emit('cancel')
}

return { __sfc: true,AuthActionType, HELP_URL, ACCESSIBILITY_URL, windowSizeStore, isSmallerThanTabletPortrait, windowHeight, changeLocale, isSelectorOpen, currentLocale, emit, currentLocaleName, menuActions, isPhone, openLocaleMenu, closeLocaleMenu, handleChangeLocale, onSelectMenuRow, cancel, __, OzMenuRows, OzMenuRowsFocusStyle, OzMenuRowsSizePreset, OzBoxColors, OzScreenSizeAwarePopoverModal, LocaleMenu }
}

})